"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var namespace_1 = __importDefault(require("../namespace"));
var apaEvents = {
    controller: {
        kill: 'controllerKill'
    },
    data: {
        update: 'dataUpdate',
        manualUpdate: 'dataManualUpdate'
    },
    framework: {
        done: 'frameworkDone'
    },
    loader: {
        started: 'loaderStarted',
        ended: 'loaderEnded',
        progress: 'loaderProgress',
        success: 'loaderSuccess',
        error: 'loaderError',
        done: 'loaderDone'
    },
    progress: {
        update: 'progressUpdate'
    },
    model: {
        get: 'modelGet',
        send: 'modelSend',
        kill: 'modelKill',
        updateModel: 'modelUpdateModel'
    },
    site: {
        resized: 'siteResized'
    },
    updater: {
        inform: 'updaterInform'
    },
    clicks: {
        done: 'clicksDone'
    },
    stylefills: {
        append: 'stylefillsAppend',
        visualDone: 'stylefillsVisualDone',
        checkStyles: 'stylefillsCheckStyles',
        setupDone: 'stylefillsSetupDone'
    }
};
namespace_1.default.namespace.extend('events', apaEvents);
